import $ from "jquery";
import {startFeaturedAutoplayIfApplicable} from "./featured_preview_autoplay";

let WebV1Functions = require('../v1/functions');

$(document).ready(function (){
    if (window.is_home_page || window.is_category_page) {
        initFeaturedObject();
    }
});

function initFeaturedObject() {
    if (window.featured_object) {
        $('#jumbotron-content').show();
        $('#category-featured-replacement').hide();

        let attributes = window.featured_object;
        let identifier = attributes['slug'] && attributes['slug'].length > 0 ? attributes['slug'] : attributes['id'];
        let jumbotron_options = {
            id: identifier,
            name: attributes['name'],
            kind: attributes['kind'],
            rating: attributes['content_rating'],
            tags: attributes['tags'],
            series: window.featured_series_name,
            provenance: attributes['provenance'],
            duration: WebV1Functions.formatDurationToHoursAndMinutes(attributes['duration']),
            screenshot: attributes['screenshot.expiring_url'],
            imdb: attributes['imdb'] ? attributes['imdb'] : null,
            title_image_url: attributes['title_image_url'],
            tvod: attributes['tvod'] ? attributes['tvod'] : false,
            tvod_buy: attributes['tvod_buy'] ? attributes['tvod_buy'] : false,
            tvod_rent: attributes['tvod_rent'] ? attributes['tvod_rent'] : false,
            active_purchase: attributes['active_purchase'] ? attributes['active_purchase'] : false,
            featured: true
        };

        updateJumbotronFeatured(jumbotron_options);

        if (window.is_content_page) {
            startFeaturedAutoplayIfApplicable(attributes);
        }
    } else {
        $('#jumbotron-content').hide();
        $('#category-featured-replacement').show();
    }
}

export function updateJumbotronFeatured(options) {
    let $featured_buttons = $('#featured-info-buttons');
    $featured_buttons.removeClass('visible');
    $featured_buttons.addClass('invisible');

    // Set Title
    let title = titleFromOptions(options);
    $('#featured-info-title').html( title );
    const titleImageContainer = $('.featured-info')[0];
    const titleImage = $('.title-image')[0];

    // If the image is already loaded, adjust padding immediately

    if (titleImage != null && titleImage.complete) {
        adjustPadding(titleImage, titleImageContainer);
    } else if (titleImage != null) {
        // If not loaded, add an event listener
        titleImage.addEventListener('load', () => adjustPadding(titleImage, titleImageContainer));
    }

    // Set Duration
    if (options.duration) {
        $('#featured-duration').html(options.duration);
    }

    if(options.imdb && options.imdb.rating && (options.imdb.rating.avg && options.imdb.rating.num_votes) ) {
        let $featured_imdb = $('#featured-imdb');
        let $imdb_score = $('#featured-imdb-rating');
        let $imdb_num_votes = $('#featured-imdb-num-votes');
        let $featured_imdb_separator = $('#featured-imdb-separator');

        if($featured_imdb && $imdb_score && $imdb_num_votes) {
            $imdb_score.text(options.imdb.rating.avg);
            $imdb_num_votes.text('(' + options.imdb.rating.num_votes + ')');
            $featured_imdb.removeClass('d-none');
            $featured_imdb_separator.removeClass('d-none');
        }
    }

    // Set Tags
    let tags_array = (options.imdb && options.imdb.genres && options.imdb.genres.length >= 3 ? options.imdb.genres : options.tags);

    //console.log(options.imdb.genres);
    //console.log(options.tags);

    if (tags_array && tags_array.length > 0) {
        let genres = '';
        for(let i=0; i < tags_array.length; i++) {
            genres += tags_array[i];
            let current = i +1;
            if(current !== tags_array.length) {
                genres += '&nbsp;&nbsp;&middot;&nbsp;&nbsp;'
            }
        }
        $('#featured-genres').html(genres);
    }

    if (options.rating) {
        $('#featured-content-rating').html(' | ' + options.rating);
    }

    let url_info = 'javascript: void(0);';
    let kind_param = 'kind=' + options.kind;
    let url_play = window.const.path.play.replace(':slug', options.id).replace('kind=movie', kind_param);

    if (options.provenance && options.provenance.length > 0) {
        url_play += '&provenance=' + options.provenance;
    }

    let $play = $('#featured-info-play');
    $play.attr("href", url_play);
    $play.addClass('click-spin');

    let $more_info_play = $('#featured-info-more-info-play');
    $more_info_play.attr("href", url_info);
    $more_info_play.data('id', window.featured_object['id']);
    $more_info_play.data('kind', window.featured_object['kind']);

    if (options.provenance && options.provenance.length > 0) {
        $more_info_play.data('provenance', options.provenance);
    }

    let $more_info = $('#featured-info-more-info');
    $more_info.attr("href", url_info);
    $more_info.data('id', window.featured_object['id']);
    $more_info.data('kind', window.featured_object['kind']);

    if (options.provenance && options.provenance.length > 0) {
        $more_info.data('provenance', options.provenance);
    }

    if ( options.tvod && (options.tvod_rent || options.tvod_buy) && !options.active_purchase ) {
        $play.hide();
        $more_info_play.show();
    } else {
        $play.show();
        $more_info_play.hide();
    }

    $featured_buttons.removeClass('invisible');
    $featured_buttons.addClass('visible');
}

export function titleFromOptions(options) {
    //test image
    //options.title_image_url = "https://placehold.co/1000x800?text=Title+Treatment&font=roboto"
    return options.title_image_url ? titleImageContainer(options.title_image_url, options.featured) : options.name;
}

function calculateViewWidthFromAspectRatio(aspectRatio) {
    return (-0.177 * aspectRatio + 26.77);
}

function adjustPadding (image, imageContainer) {
    // Get the image's intrinsic (natural) dimensions
    const imageWidth = image.naturalWidth;
    const imageHeight = image.naturalHeight;

    // Avoid division by zero if the image fails to load
    if (imageWidth > 0) {
      // Calculate the aspect ratio and calculate padding based on it by assuming that for
      // aspect ratio of 10% padding should be 25vw and for aspect ratio of 100% padding should be 9vw
      // calculatedPading is calculated from the padding for the widest screen as 25/30 that was previously
      // hardcoded in css
      const aspectRatio = ((imageHeight / imageWidth) * 100).toFixed(0);
      const calculatedWidePadding = calculateViewWidthFromAspectRatio(aspectRatio)
      const calculatedPadding = (calculatedWidePadding * 0.833)

      // set the container top to calculated paddings
      imageContainer.style.setProperty('--top-pad-wide', calculatedPadding.toFixed(0) + 'vw');
      imageContainer.style.setProperty('--top-pad', calculatedPadding.toFixed(0) + 'vw');
    }
  };

function titleImageContainer(title_image_url, featured=false) {
    let span_cols = featured ? '12' : '6';
    return `<div class="p-0 col-${span_cols}"><img src="${title_image_url}" class="img-responsive mw-100 w-100 img-shadow title-image" /></div>`;
}